var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.998,
    height: 18,
    viewBox: "0 0 17.998 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit_icon",
    "data-name": "Edit icon",
    d: "M.748,18H.661A.662.662,0,0,1,.2,17.807.673.673,0,0,1,0,17.275l.513-4.981a1.842,1.842,0,0,1,.53-1.13L11.747.426A1.848,1.848,0,0,1,14.187.5l3.255,3.269.015.009a1.784,1.784,0,0,1,.064,2.492L6.807,17.021a1.887,1.887,0,0,1-1.117.527ZM9.007,5.012,1.764,12.192,1.369,16.6l4.395-.411,7.2-7.2ZM12.9,1.037,9.837,4.185l3.926,3.948L16.906,5.06Z",
    fill: "#f8f8f8",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDark);
export default __webpack_public_path__ + "static/media/edit_icon_dark.6d218c146325c213c5d8bb709cdf9294.svg";
export { ForwardRef as ReactComponent };